import { ref, computed, provide, inject, type ComputedRef, type Ref } from 'vue'
import type { ActiveElement } from '@collection-selector/types/move-slide-modal.type'

type MoveItemModal = {
  open: (type: ActiveElement) => void
  close: () => void
  isOpen: Readonly<ComputedRef<boolean>>
  activeElement: Readonly<Ref<ActiveElement | null>>
}

const MoveItemModalKey = Symbol('moveItemModal')

export function provideMoveSlideModal() {
  const activeElement = ref<ActiveElement | null>(null)
  const isOpen = computed(() => !!activeElement.value)
  const close = () => (activeElement.value = null)

  const open = (type: ActiveElement) => {
    activeElement.value = type
  }

  const store = {
    isOpen,
    activeElement,
    open,
    close,
  }

  provide<MoveItemModal>(MoveItemModalKey, store)

  return store
}

export function useMoveSlideModal() {
  const store = inject<MoveItemModal>(MoveItemModalKey)

  if (!store) {
    throw new Error('useMoveItemModal() is called without provider.')
  }

  return store
}
